import * as angular from 'angular';

import { Inject, Injectable, Optional, SkipSelf } from "@angular/core";
import { downgradeInjectable } from "@angular/upgrade/static";

import { HttpService } from '../../../../shared/ajs-bridges/http.service';
import { BasicDataSubService } from '../../../../shared/basic-data-management/basic-data-subservice.class';

import { HttpClient } from "@angular/common/http";
import { Observable } from 'rxjs';

import { CachedDataSurveyService } from '../../../../technical-modules/tasks/services/cached-data-survey.service';

import { AgenceTLR } from '../entities/agence-tlr.entity';

@Injectable({ providedIn: 'root' })
export class AgenceService {
	private path: string;

	private agenceTLRSubService!: BasicDataSubService<AgenceTLR>;

	constructor( //
		@Inject(HttpClient) httpClient: HttpClient, //
		@Inject(HttpService) private httpService: HttpService, //
		@Inject(CachedDataSurveyService) private cachedDataSurveyService: CachedDataSurveyService, //
		@Optional() @SkipSelf() previousInstance?: AgenceService //
	) {
		if (previousInstance) {
			throw new Error(
				'AgenceService is already loaded. Import it in the AppModule only');
		}
		this.path = (window as any).baseApiPath;
		let agencesChanged$ = this.cachedDataSurveyService.getChangeNotification("Agence");
		this.agenceTLRSubService = new BasicDataSubService<AgenceTLR>(httpClient, this.path + 'agences?format=TLR', agencesChanged$);
	}

	// Methode recuperant toutes les agences.
	public getAgences(): Promise<any> {
		let url = this.path + 'agences/';
		console.log("[Service Agence] - getAgences");
		console.log(url);
		let result = this.httpService.get(url);
		return result;
	}

	// Methode permettant de recuperer une agence a partir de son identifiant.
	public getAgenceById(id: number): Promise<any> {
		let url = this.path + 'agences/' + id;
		console.log("[Service Agence] - get");
		console.log(url);
		let result = this.httpService.get(url);
		return result;
	}

	// Methode permettant d'ajouter une agence.
	public create(data: any): Promise<any> {
		let url = this.path + 'agences/';
		console.log("[Service Agence] - create");
		console.log(url);
		let result = this.httpService.post(url, data);
		return result;
	}

	// Methode permettant de modifier une agence.
	public update(id: number, data: any): Promise<any> {
		let url = this.path + 'agences/' + id;
		console.log("[Service Agence] - update");
		console.log(url);
		let result = this.httpService.put(url, data);
		return result;
	}

	// Methode permettant de supprimer un agence.
	public deleteAgence(id: number): Promise<any> {
		let url = this.path + 'agences/' + id;
		console.log("[Service Agence] - delete");
		console.log(url);
		let result = this.httpService.delete(url);
		return result;
	}

	// Methode de recuperation des agences.
	public getAgencesWithOuvrages(): Promise<any> {
		let url = this.path + 'agences?format=perimetreCAC';
		console.log("[Service Agence] - getAgences (with ouvrages)");
		console.log(url);
		let result = this.httpService.get(url);
		return result;
	}

	///////////////////////////////////////////
	// Nouvelles fonctions en pur Angular 12 //
	///////////////////////////////////////////

	// Methode permettant le chargement de toutes les agences
	public getAgenceTLRList(): Observable<AgenceTLR[]> {
		return this.agenceTLRSubService.getList();
	}

	// Methodes permettant le chargement de toutes les agences, selon differentes classifications et indexs
	// (NB: on procede a toutes les classifications en une fois, ce qui permet de n'iterer qu'une seule fois pour tous les resultats)
	public getAgenceTLRMapById(): Observable<Map<number, AgenceTLR>> {
		return this.agenceTLRSubService.getMapById();
	}
	public getAgenceTLRById(id: number): Observable<AgenceTLR> {
		return this.agenceTLRSubService.getKnownById(id, "ParcTLR");
	}
}

angular
	.module('auroraApp')
	.service('agencesService', downgradeInjectable(AgenceService));